export default __webpack_public_path__ + "static/media/Riepilogo1.7516be31.svg";